"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    propertyId: zod_1.z.number(),
    insectId: zod_1.z.number(),
});
exports.responseSchema = zod_1.z
    .array(zod_1.z.object({
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    biofix: zod_1.z.array(zod_1.z.string()),
}))
    .or(zod_1.z.object({
    error: zod_1.z.string(),
}))
    .nullable();
//# sourceMappingURL=insectBiofix.js.map